module.exports = "//cdn.mxpnl.com/static/asset-cache/1d9d2341733ad76f0d35095f579f8f69/iron/common/widgets/intro/images/profiles/jill.svg";